import { Link } from "react-router-dom";
import { categories, navLinks, siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto grid w-full max-w-7xl gap-10 px-4 py-14 md:grid-cols-12 md:px-8 md:py-16">
        <div className="md:col-span-5">
          <Link to="/" className="flex items-center gap-2.5" aria-label="吃瓜复盘局首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
              <i className="ri-flashlight-fill text-lg"></i>
            </span>
            <span className="font-heading text-xl font-bold text-background-50">
              {siteInfo.name}
            </span>
          </Link>
          <p className="mt-4 max-w-md text-sm leading-7 text-background-100/75">
            {siteInfo.shortDesc}
          </p>
          <p className="mt-5 text-sm text-background-100/75">
            联系邮箱：
            <a
              href={`mailto:${siteInfo.email}`}
              className="text-accent-300 underline-offset-4 hover:underline"
            >
              {siteInfo.email}
            </a>
          </p>
        </div>

        <nav className="md:col-span-3" aria-label="页脚导航">
          <h2 className="text-sm font-medium text-background-50">站点导航</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            {navLinks.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className="text-background-100/75 transition-colors hover:text-accent-300"
                >
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/events"
                className="text-background-100/75 transition-colors hover:text-accent-300"
              >
                全部事件复盘
              </Link>
            </li>
          </ul>
        </nav>

        <nav className="md:col-span-4" aria-label="主题分类">
          <h2 className="text-sm font-medium text-background-50">主题分类</h2>
          <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm">
            {categories.map((category) => (
              <li key={category.slug}>
                <Link
                  to={`/events?category=${category.slug}`}
                  className="text-background-100/75 transition-colors hover:text-accent-300"
                >
                  {category.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="border-t border-background-50/15">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-3 px-4 py-6 text-xs text-background-100/60 sm:flex-row sm:items-center sm:justify-between md:px-8">
          <p>
            © {new Date().getFullYear()} {siteInfo.name} · 内容基于公开信息整理
          </p>
          <p className="max-w-xl leading-6">
            本站内容仅为信息梳理与观点分析，不构成对任何当事人的定性结论；如涉及隐私信息将一律脱敏处理。
          </p>
        </div>
      </div>
    </footer>
  );
}